const CODE = '[a-z0-9]+(-[a-z0-9]+)*';
export const standardFields = [
    { name: 'name', label: 'Nombre', required: true, maxLength: 160 },
    { name: 'code', label: 'Código', required: true, pattern: CODE, minLength: 2, maxLength: 80, help: 'Por ejemplo: seguridad o tss. No se cambia después.' },
    { name: 'track', label: 'Pista', options: [['core', 'Core · backend'], ['vite', 'Vite · frontend']] },
    { name: 'kind', label: 'Tipo', options: [['standard', 'Estándar'], ['ui_guide', 'Guía de interfaz']] },
    { name: 'description', label: 'Descripción', type: 'textarea', nullable: true },
];
export const versionFields = [
    { name: 'number', label: 'Número de versión', required: true, pattern: '[0-9]+[.][0-9]+[.][0-9]+', help: 'Formato: 1.0.0. Se guarda como borrador.' },
    { name: 'summary', label: 'Resumen', type: 'textarea', nullable: true, rows: 2 },
    { name: 'content', label: 'Documento completo (Markdown)', type: 'textarea', required: true, rows: 10,
        help: 'Después añade las secciones: permiten identificar qué reglas son obligatorias.' },
];
export const sectionFields = [
    { name: 'key', label: 'Clave de la sección', required: true, pattern: CODE, minLength: 2, maxLength: 80 },
    { name: 'title', label: 'Título de la sección', required: true, maxLength: 200 },
    { name: 'rigidity', label: 'Nivel de la regla', nullable: true, options: [['', 'Sin clasificar'], ['RIGID', 'Obligatoria · RIGID'], ['CONTEXTUAL', 'Depende del contexto · CONTEXTUAL'], ['GUIDELINE', 'Recomendación · GUIDELINE']] },
    { name: 'sort_order', label: 'Orden', type: 'number', min: 0, required: true },
    { name: 'content', label: 'Reglas de la sección (Markdown)', type: 'textarea', rows: 8, required: true },
];
